module.exports = __webpack_public_path__ + "img/txtennova_logotype_negative.8939f3c7.svg";